exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table>tr>td[data-v-46bb2db6]{width:30%;height:30px}.margin-5px[data-v-46bb2db6]{margin-right:5px}.width-20px[data-v-46bb2db6]{table-layout:fixed;width:20px}.padding-5px[data-v-46bb2db6]{padding-right:3%;padding-left:3%}.table-responsive img[data-v-46bb2db6]{width:60px}table>tr>td[data-v-46bb2db6]:nth-child(odd){font-weight:600}", ""]);

// exports
